export default "void main() {\r\n    gl_FragColor = vec4(1.0);\r\n}\r\n";